export default "__VITE_ASSET__Bttd7C5y__"